import React from 'react'
import './MapsOfDriver.css'
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';
import { useReducer , useEffect, useState, useRef} from 'react';
import { options} from '../../orderTrip/mapAssets/mapAssets'
import InsertNewOrder from './InsertNewOrder';
import ActivOrders from './ActivOrders'
import customerIco from '../../../img/customerIco.png'
import {  Modal, FloatButton } from 'antd';

import CloseButton from 'react-bootstrap/CloseButton';
import DriversWithStatus from './DriversWithStatus';
import CreateNewOrder from './CreateNewOrder';
import calculateDriverStats from '../../../function/calculateDriverStats';
import ClientMessageForm from './ClientMessageForm';
import { MailOutlined } from '@ant-design/icons';

// Maps Setting
const api_key = process.env.REACT_APP_GOOGLE_KEY;
const containerStyle = {
    width: '100%',
    height: '100%',
  }




const MapsOfDrivers = ({listOfDrivers ,listOfOrders, setShowMap, server, token}) => {
    const [createOrderForDriver, setCreateOrderForDriver] = useState(null)
    const [showMessageModal, setShowMessageModal] = useState(false)
    const closeMessageModal = () => setShowMessageModal(false)

    const whatTimeIsDriverReady  = (id) => {
        if(listOfOrders){
                const bussyDrivers = calculateDriverStats(listOfOrders)
                
                return bussyDrivers && bussyDrivers[id] ? bussyDrivers[id] : null
        }
    }


    const [onTheMap , setOnTheMap] = useState({
        mapZoom: 12,
        centerPositionOnMap: {lat:50.46017587548713, lng: 13.41622507444904},
        places: ["places"],
    })

    // MAP INIT
    const { isLoaded } = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_KEY,
        libraries: onTheMap.places,
        })
    
    // Close map
    const handleCloseMap = () => {
        localStorage.setItem('openMap', 0);
        setShowMap(false)
    }


    // MAPA
    if(isLoaded){
        return (
            <div className='mapsOfDrivers'>
                <div className='closeMapWindow'>
                    <CloseButton  onClick={ handleCloseMap } />
                </div>
               

                <div className='driverInfo'>
                    {listOfOrders.length > 0 && <ActivOrders listOfOrders={listOfOrders} listOfDrivers={listOfDrivers}/>}
                </div>
               
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={onTheMap.centerPositionOnMap}
                    zoom={onTheMap.mapZoom}
                    options={options}
                > 
                {/* Zobrazí řidiče  na mapě*/}
                {listOfDrivers.map( (oneDriver, index) => {
                    // Vybere barvu řidiče
                    let colorOfDriver = ""
                    const statusOfDriver = parseInt( oneDriver.status)
                    if (statusOfDriver === 1 ){
                        colorOfDriver = "green"
                    }
                    else if (statusOfDriver === 2){
                        colorOfDriver = "red"
                    }
            
                    if(statusOfDriver !== 0){
                        return(
                        <Marker
                            key={index}
                            label={ {
                                text: oneDriver.nick,
                                className: `marker-label  ${colorOfDriver}`,
                                color: 'white',
                                }}
                            
                            position={{lat:parseFloat( oneDriver.latitude), lng: parseFloat(oneDriver.longitude)}} 
                            icon={{url: "https://abcnet.cz/taxi/avatarOfDrivers/" + oneDriver.id + ".jpeg", scaledSize: new window.google.maps.Size(70, 60)}}
                        >
                        </Marker>
                      
                    )
                    }
         
                })}
                {/*  Zobrazí Zakázky  na mapě*/}
                {
                    listOfOrders.map( (oneOrder, index) => {
                        const status = parseInt(oneOrder.status)
                        if(status <= 2){
                            return (
                            <Marker
                            key={index}
                            icon={{url: customerIco, scaledSize: new window.google.maps.Size(30, 30)}}
                            
                            
                            position={{lat:parseFloat( oneOrder.latitude), lng: parseFloat(oneOrder.longitude)}} 
                            
                        >
                        </Marker>
                        )
                        }
                       
                    })
                }
                </GoogleMap>
                {/* <InsertNewOrder server={server} token={token}/> */}
                <div className='driverStatus'>
                    <DriversWithStatus whatTimeIsDriverReady={whatTimeIsDriverReady} listOfDrivers={listOfDrivers} listOfOrders={listOfOrders} setCreateOrderForDriver={setCreateOrderForDriver}/>
                </div>
                
                {/* Modal create order */}
                {createOrderForDriver && <CreateNewOrder whatTimeIsDriverReady={whatTimeIsDriverReady} listOfDrivers={listOfDrivers} setCreateOrderForDriver={setCreateOrderForDriver} createOrderForDriver={createOrderForDriver} server={server} token={token}/> }
               
                {/* Modal zpráva pro klienty */}
                {!showMessageModal && <FloatButton onClick={() => setShowMessageModal(true)} icon={<MailOutlined />}/>}
                {showMessageModal && (
                    <Modal title="Upozornění pro klienty v aplikaci" open={showMessageModal} onOk={closeMessageModal} onCancel={closeMessageModal} footer={false}>
                        <ClientMessageForm server={server} token={token} closeMessageModal={closeMessageModal}/>
                    </Modal>
                )}
            </div>
        )
    }

}

export default MapsOfDrivers
